import { css } from 'styled-components';

export const stableScrollGutter = css`
  scrollbar-gutter: stable;
  margin-inline-end: calc(-1 * var(--scrollbar-width));
`;

export const selfPaddedScrollGutter = (padding: string) => css`
  scrollbar-gutter: stable;
  padding-inline-end: calc(${padding} - var(--scrollbar-width));
`;

/** How far a focused field's halo reaches past its own border box. */
export const FOCUS_HALO_REACH = '3px';

export const focusHaloBleed = css`
  scrollbar-gutter: stable;
  padding-inline: ${FOCUS_HALO_REACH};
  margin-inline-start: calc(-1 * ${FOCUS_HALO_REACH});
  margin-inline-end: calc(-1 * ${FOCUS_HALO_REACH} - var(--scrollbar-width));
`;
